import { getLicensingStatus } from 'core/core.selectors';
import { canAccessTasks } from 'core/utils/functions';
import { getLoadingLicensingStatus } from 'entities/company/company.selectors';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

/*
 * The sidebar hides Tasks for a contract with the hide_tasks entitlement; this keeps a typed url from
 * getting there anyway, whatever the agops list flag says. Like the other entitlement routes it waits
 * for the licensing status, so a stale contract from the previous org never decides.
 */
const TasksEntitlementRoute = () => {
  const licensingStatus = useSelector(getLicensingStatus);
  const isLoadingLicensingStatus = useSelector(getLoadingLicensingStatus);

  if (isLoadingLicensingStatus || !licensingStatus) {
    return null;
  }

  if (!canAccessTasks(licensingStatus)) {
    return <Navigate to='/hall-of-companies' replace />;
  }

  return <Outlet />;
};

export default TasksEntitlementRoute;
